import { z } from "zod";

export const SEEKER_SCREEN_PART_NAME = "seeker_screen";

export const seekerScreenDogSchema = z
    .object({
        listingId: z.string().min(1).max(128),
        name: z.string().min(1).max(120).optional(),
    })
    .strict();

export const seekerScreenProviderSchema = z
    .object({
        providerId: z.string().min(1).max(128),
        name: z.string().min(1).max(120).optional(),
    })
    .strict();

export const seekerScreenContextSchema = z
    .object({
        page: z.string().min(1).max(256),
        query: z.record(z.string().max(128), z.string().max(512)).optional(),
        dog: seekerScreenDogSchema.optional(),
        provider: seekerScreenProviderSchema.optional(),
    })
    .strict();

export type SeekerScreenContext = z.infer<typeof seekerScreenContextSchema>;
